export const Banner = ({ title, message, className }) => {
  return (
    <div className={`bg-gradient-to-b from-[#09274A] to-[#0488AF] rounded-xl p-8 mb-4 shadow-lg ${className}`}>
      <h2 className="text-3xl font-extrabold text-center text-white drop-shadow-lg animate-[fadeIn_1s_ease-out]">
        {title}
      </h2>
      <p className="text-center text-indigo-100 mt-3 font-medium drop-shadow-md animate-[fadeIn_1.5s_ease-out]">
        {message}
      </p>
    </div>
  );
};

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
}
